module.exports = {
	"config": {
		"siteTitle": "Blog de Sochan",
		"siteDescr": "sochan's Tech blog",
		"siteAuthor": "sochan",
		"siteTelegramUrl": "#",
		"siteTwitterUrl": "#",
		"siteGithubUrl": "#",
		"siteEmailUrl": "#",
		"siteRssUrl": "#",
		"siteVkUrl": "#",
		"googleAnalyticsId": "UA-71349602-3",
		"linkPrefix": "/"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/a_neural_attentino_model_for_abstractive_setntence_summarization",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/a_neural_attentino_model_for_abstractive_setntence_summarization",
				"stem": "index",
				"path": "articles/a_neural_attentino_model_for_abstractive_setntence_summarization/index.md"
			},
			"requirePath": "articles/a_neural_attentino_model_for_abstractive_setntence_summarization/index.md",
			"path": "/attention_abstractive_sentence_summarization/",
			"data": {
				"title": "A Neural Attiention Model for Abstractive Sentence Summarization",
				"date": "2017-02-05",
				"layout": "post",
				"path": "/attention_abstractive_sentence_summarization/",
				"category": "paper",
				"description": "A Neural Attiention Model for Abstractive Sentence Summarizationの概要"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/batch_normalization",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/batch_normalization",
				"stem": "index",
				"path": "articles/batch_normalization/index.md"
			},
			"requirePath": "articles/batch_normalization/index.md",
			"path": "/batch_normalization/",
			"data": {
				"title": "batch normalization",
				"date": "2017-01-05",
				"layout": "post",
				"path": "/batch_normalization/",
				"category": "nn",
				"description": "batch normalizationまとめのまとめ"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/chainer_document",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/chainer_document",
				"stem": "index",
				"path": "articles/chainer_document/index.md"
			},
			"requirePath": "articles/chainer_document/index.md",
			"path": "/chainer_document/",
			"data": {
				"title": "chainer document",
				"date": "2017-01-09",
				"layout": "post",
				"path": "/chainer_document/",
				"category": "nn",
				"description": "chainer関数の知らなかったけど便利そうな関数まとめ"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/character_level_convolutional_networks_for_text_classification",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/character_level_convolutional_networks_for_text_classification",
				"stem": "index",
				"path": "articles/character_level_convolutional_networks_for_text_classification/index.md"
			},
			"requirePath": "articles/character_level_convolutional_networks_for_text_classification/index.md",
			"path": "/character-level_Convolutional_Networks_for_Text_Classification/",
			"data": {
				"title": "Character-level Convolutional Networks for Text Classification",
				"date": "2017-01-04",
				"layout": "post",
				"path": "/character-level_Convolutional_Networks_for_Text_Classification/",
				"category": "paper",
				"description": "Character-level Convolutional Networks for Text Classificationの要約"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/color_python_print",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/color_python_print",
				"stem": "index",
				"path": "articles/color_python_print/index.md"
			},
			"requirePath": "articles/color_python_print/index.md",
			"path": "/color_python_print/",
			"data": {
				"title": "pythonでの標準出力に色をつける",
				"date": "2016-12-27",
				"layout": "post",
				"path": "/color_python_print/",
				"category": "python",
				"description": "termcolorを使ってpythonでの標準出力に色をつける"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/django-simple-relationship",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/django-simple-relationship",
				"stem": "index",
				"path": "articles/django-simple-relationship/index.md"
			},
			"requirePath": "articles/django-simple-relationship/index.md",
			"path": "/django-simple-relationships/",
			"data": {
				"title": "simple django relationship",
				"date": "2016-12-16",
				"layout": "post",
				"path": "/django-simple-relationships/",
				"category": "django",
				"description": "Djangoで簡単なフォロー機能を実装してみる"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/doc2vec",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/doc2vec",
				"stem": "index",
				"path": "articles/doc2vec/index.md"
			},
			"requirePath": "articles/doc2vec/index.md",
			"path": "/doc2vec/",
			"data": {
				"title": "Distributed Representations of Sentences and Documents",
				"date": "2017-02-10",
				"layout": "post",
				"path": "/doc2vec/",
				"category": "paper",
				"description": "Distributed Representations of Sentences and Documentsの概要"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/effective_approaches_attention_based_nmt",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/effective_approaches_attention_based_nmt",
				"stem": "index",
				"path": "articles/effective_approaches_attention_based_nmt/index.md"
			},
			"requirePath": "articles/effective_approaches_attention_based_nmt/index.md",
			"path": "/effective_approaches_abnmt/",
			"data": {
				"title": "Effective Approaches to Attention-based Neural Machine Translation",
				"date": "2017-03-29",
				"layout": "post",
				"path": "/effective_approaches_abnmt/",
				"category": "paper",
				"description": "Effective Approaches to Attention-based Neural Machine Translationの概要"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/eminem_vs_snoopdogg",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/eminem_vs_snoopdogg",
				"stem": "index",
				"path": "articles/eminem_vs_snoopdogg/index.md"
			},
			"requirePath": "articles/eminem_vs_snoopdogg/index.md",
			"path": "/eminem_vs_snoopdogg/",
			"data": {
				"title": "洋楽ラッパーの歌詞の分類問題をscrapyとscikit-learnを使ってやってみる",
				"date": "2016-07-12",
				"layout": "post",
				"path": "/eminem_vs_snoopdogg/",
				"category": "NLP",
				"description": "pythonライブラリscikit-learnを使って洋楽歌詞をアーティスト別に分類してみる"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/ios_youtube_restriction_error",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/ios_youtube_restriction_error",
				"stem": "index",
				"path": "articles/ios_youtube_restriction_error/index.md"
			},
			"requirePath": "articles/ios_youtube_restriction_error/index.md",
			"path": "/ios-youtube-restriction-error/",
			"data": {
				"title": "youtube-ios-player-helplerでvevoの動画が再生できない問題",
				"date": "2016-11-23",
				"layout": "post",
				"path": "/ios-youtube-restriction-error/",
				"category": "iOS",
				"description": "This video contains content from VEVO. It is restricted from playback on certain sites. Watch on YouTubeの対処法"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/julia_bow",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/julia_bow",
				"stem": "index",
				"path": "articles/julia_bow/index.md"
			},
			"requirePath": "articles/julia_bow/index.md",
			"path": "/julia_bow/",
			"data": {
				"title": "julia nlp入門 [1]",
				"date": "2016-12-05",
				"layout": "post",
				"path": "/julia_bow/",
				"category": "julia",
				"description": "bowもどきをしながらjuliaに入門してみる"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/lm_with_gated_convolutional_networks",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/lm_with_gated_convolutional_networks",
				"stem": "index",
				"path": "articles/lm_with_gated_convolutional_networks/index.md"
			},
			"requirePath": "articles/lm_with_gated_convolutional_networks/index.md",
			"path": "/gated_conv/",
			"data": {
				"title": "Language Modeling with Gated Convolutional Networks",
				"date": "2017-02-20",
				"layout": "post",
				"path": "/gated_conv/",
				"category": "paper",
				"description": "Language Modeling with Gated Convolutional Networksの概要"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/neural_machine_translation_by_jointly_leaning_to_align_and_translate",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/neural_machine_translation_by_jointly_leaning_to_align_and_translate",
				"stem": "index",
				"path": "articles/neural_machine_translation_by_jointly_leaning_to_align_and_translate/index.md"
			},
			"requirePath": "articles/neural_machine_translation_by_jointly_leaning_to_align_and_translate/index.md",
			"path": "/neural_machine_translation_by_jointly_leaning_to_align_and_translate/",
			"data": {
				"title": "Neural Machine Translation by Jointly Leaning to Align and Translate",
				"date": "2017-01-09",
				"layout": "post",
				"path": "/neural_machine_translation_by_jointly_leaning_to_align_and_translate/",
				"category": "paper",
				"description": "Neural Machine Translation by Jointly Leaning to Align and Translateの概要"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/nltk_tokenize_regexp_tokenizer",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/nltk_tokenize_regexp_tokenizer",
				"stem": "index",
				"path": "articles/nltk_tokenize_regexp_tokenizer/index.md"
			},
			"requirePath": "articles/nltk_tokenize_regexp_tokenizer/index.md",
			"path": "/nltk_tokenize_regezptoken/",
			"data": {
				"title": "nltkのtokenize.RegexpTokenizer()に引数を与えてtokenizeの条件を設定する",
				"date": "2016-06-16",
				"layout": "post",
				"path": "/nltk_tokenize_regezptoken/",
				"category": "NLP",
				"description": "nltkのtokenizeの正規表現を自分で編集する"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/seq_to_seq_leaning_with_neural_networks",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/seq_to_seq_leaning_with_neural_networks",
				"stem": "index",
				"path": "articles/seq_to_seq_leaning_with_neural_networks/index.md"
			},
			"requirePath": "articles/seq_to_seq_leaning_with_neural_networks/index.md",
			"path": "/seq_2_seq/",
			"data": {
				"title": "Sequence to Sequence Leaning with Neural Networks",
				"date": "2017-01-25",
				"layout": "post",
				"path": "/seq_2_seq/",
				"category": "paper",
				"description": "Sequence to Sequence Leaning with Neural Networksの概要"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/very_deep_convnets_for_nlp",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/very_deep_convnets_for_nlp",
				"stem": "index",
				"path": "articles/very_deep_convnets_for_nlp/index.md"
			},
			"requirePath": "articles/very_deep_convnets_for_nlp/index.md",
			"path": "/convnets_for_nlp/",
			"data": {
				"title": "very deep convolutional networks for natural language processing",
				"date": "2017-01-03",
				"layout": "post",
				"path": "/convnets_for_nlp/",
				"category": "paper",
				"description": "very deep convolutional networks for natural language processingの要約"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md"
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About me",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/contact",
				"stem": "index",
				"path": "pages/contact/index.md"
			},
			"requirePath": "pages/contact/index.md",
			"path": "/contact/",
			"data": {
				"title": "Contact me",
				"layout": "page",
				"path": "/contact"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0